var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#330055",
    width: 100,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#330055",
    cx: 50,
    cy: 0,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#36095d"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 50,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#381366",
    cx: 50,
    cy: 100,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3a1b6e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 150,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 150,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#3c2377",
    cx: 50,
    cy: 200,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e2a80"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 250,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 250,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#3f3188",
    cx: 50,
    cy: 300,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#403991"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 350,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 350,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#414099",
    cx: 50,
    cy: 400,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4147a2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 450,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 450,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#414eab",
    cx: 50,
    cy: 500,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4156b3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 550,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 550,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#415dbc",
    cx: 50,
    cy: 600,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4065c5"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 650,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 650,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#3f6ccd",
    cx: 50,
    cy: 700,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e74d6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 750,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 750,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#3c7bde",
    cx: 50,
    cy: 800,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3983e6"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 850,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 850,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#368aef",
    cx: 50,
    cy: 900,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3392f7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 950,
    r: 50
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 950,
    r: 50
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#2F9AFF",
    cx: 50,
    cy: 1000,
    r: 50
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground6);
export default __webpack_public_path__ + "static/media/background6.c98988ff546b89af75bf5ec15c3185fa.svg";
export { ForwardRef as ReactComponent };